import PropTypes from 'prop-types'
import cn from '../modules/cn'

function IconContainer({
  className,
  children,
}) {
  return (
    <div
      className={cn(
        'rounded-full w-5 h-5 bg-gray-900 text-sm text-white flex justify-center items-center',
        className,
      )}
    >
      {children}
    </div>
  )
}

IconContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: cn.propType,
}

IconContainer.defaultProps = {
  className: null,
}

export default IconContainer
